import _extends from "babel-runtime/helpers/extends";
import _Object$keys from "babel-runtime/core-js/object/keys";
import _objectWithoutProperties from "babel-runtime/helpers/objectWithoutProperties";
import React from "react";
import { tags } from "./tags";
import { connect } from "react-redux";
import selectors from "../selectors/lion-selectors";
import { PropTypes } from "prop-types";
import isPropValid from "@emotion/is-prop-valid";

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var replacements = ownProps.replacements;
  // If no lionkey was supplied, use props.children as the translatedString. This makes lionkey optional
  // and you can use the same styled component for either lion or non-lion purposes.
  return {
    translatedString: ownProps.lionkey && selectors.getLionTranslatedStringWithFallback(state, ownProps.lionkey, ownProps.fallback, replacements)
  };
};

var createLion = function createLion(Tag) {
  var LionComponent = React.memo(function (props) {
    var dispatch = props.dispatch,
        className = props.className,
        lionkey = props.lionkey,
        replacements = props.replacements,
        translatedString = props.translatedString,
        appResources = props.appResources,
        productResources = props.productResources,
        otherProps = _objectWithoutProperties(props, ["dispatch", "className", "lionkey", "replacements", "translatedString", "appResources", "productResources"]);

    var propsToPassOn = _Object$keys(otherProps).filter(isPropValid).reduce(function (acc, prop) {
      acc[prop] = otherProps[prop];
      return acc;
    }, {});

    if (typeof translatedString !== "string") {
      return React.createElement(
        Tag,
        _extends({ "data-qa": lionkey }, propsToPassOn, { className: className }),
        translatedString || props.children
      );
    }
    return React.createElement(Tag, _extends({
      "data-qa": lionkey
    }, propsToPassOn, {
      className: className,
      dangerouslySetInnerHTML: {
        __html: translatedString
      }
    }));
  });
  var ConnectedComponent = connect(mapStateToProps)(LionComponent);

  ConnectedComponent.propTypes = {
    className: PropTypes.string,
    fallback: PropTypes.string,
    replacements: PropTypes.objectOf(PropTypes.string)
  };

  return ConnectedComponent;
};

export default tags.reduce(function (acc, tagName) {
  acc[tagName] = createLion(tagName);
  return acc;
}, {});